import * as React from 'react';
import { times } from 'lodash';
import DataTable, { IDataTableColumn } from 'react-data-table-component';
import { tableLoading } from 'src/modules/Alert/ControlCenter/utils/placeholders';
import { IEmailsLogs } from 'src/share/types/emailsConfiguration';
import { renderLoadedText } from 'src/share/utils/placeholders';

export interface IEmailCategoryProps {
  emailsLogs: IEmailsLogs[];
  loading: boolean;
  onSizeChanged: (size: number, page: number) => void;
  onPageChanged: (page: number) => void;
  onSort: (column: IDataTableColumn, sortDirection: string) => void;
  total: number;
}

const columns = (isLoading: boolean) => [
  { name: 'Date', width: '200px', sortable: true, ...tableLoading('date', isLoading, 100) },
  { name: 'Email type', sortable: false, ...tableLoading('displayName', isLoading, 60) },
  { name: 'Log id', sortable: false, ...tableLoading('logId', isLoading, 60) }
];

const EmailsLogsTable: React.SFC<IEmailCategoryProps> = (props) => {
  const { emailsLogs, loading, onSort, total, onSizeChanged, onPageChanged } = props;
  const loadingArray = React.useRef(times(10, Object));
  return (
    <DataTable
      columns={columns(loading)}
      data={loading ? loadingArray.current : emailsLogs}
      theme={'gmcngine-emailsLogs__table'}
      noHeader={true}
      fixedHeader={true}
      subHeader={false}
      highlightOnHover={true}
      className="application-emailsLogs__table"
      expandableRows={true}
      expandOnRowClicked={true}
      responsive={true}
      pagination={true}
      paginationServer={true}
      paginationTotalRows={total}
      sortServer={true}
      onSort={onSort}
      onChangeRowsPerPage={onSizeChanged}
      onChangePage={onPageChanged}
      expandableRowsComponent={!loading ? <EmailTableDetails /> : <></>}
    />
  );
}

export default EmailsLogsTable;


const EmailTableDetails = (props) => {
  return (
    <div className="application-emailsLogs__table__users_sent">
      {props.loading ?
        <h3>loading</h3> :
        props.data.usersSent.map(user => <EmailLogHistoryRow key={user} user={user} loading={props.loading} />)}
    </div>
  )
}

export interface IEmailLogHistoryRowProps {
  user: string;
  loading: boolean;
}

const EmailLogHistoryRow = ({ loading, user }: IEmailLogHistoryRowProps) =>
  alert &&
  <div className="email-log-record">
    <div className="email-log-record__info">
      <h5>User email:</h5>
      <p>{renderLoadedText(user, !loading, 1, 20)}</p>
    </div>
  </div>



// WEBPACK FOOTER //
// ./src/modules/UserSettings/EmailsConfiguration/components/EmailsLogsTable.tsx